module.exports = __webpack_public_path__ + "img/HeBo Trailers-10.2267d3fd.jpg";